<template>
  <div id="home" dir="rtl">
    <article class="container">
      <h1 class="main-title">אודות</h1>
    </article>

    <article class="container">
      <about id="about" />
    </article>

    <article>
      <copyRights id="copyRights" />
    </article>
  </div>
</template>

<script>
import about from "@/components/About.vue";
import copyRights from "@/components/CopyRights.vue";

export default {
  name: "home",
  components: {
    about,
    copyRights
  },
  title: "איילת נוף אודות",
  meta: [
    {
      name: "description",
      content: "דף הבית על אודותיה של עורכת דין ונוטריון איילת נוף"
    }
  ]
};
</script>

<style scoped>
.main-title {
  padding-bottom: 2.8vh;
}
#about {
  margin: 0 auto;
  width: 73%;
}
</style>